import React from 'react'
import styles from './UIGamePlayerInfoHeader.module.scss'
import {ImageURL} from '@colonist/types'
import {UIGamePlayerInfoHeaderPointsPublic} from './UIGamePlayerInfoHeaderPointsPublic/UIGamePlayerInfoHeaderPointsPublic'
import clsx from 'clsx'
import {UIGamePlayerInfoHeaderPointsPrivate} from './UIGamePlayerInfoHeaderPointsPrivate/UIGamePlayerInfoHeaderPointsPrivate'

export interface UIGamePlayerInfoHeaderProps {
    color: string
    avatar: ImageURL
    username: string
    isMyPlayer: boolean
    isToggledEndTurn: boolean
    pointsPublic: number
    pointsPrivate?: number
}

export const UIGamePlayerInfoHeader = ({
    color,
    avatar,
    username,
    isMyPlayer,
    isToggledEndTurn,
    pointsPublic,
    pointsPrivate,
}: UIGamePlayerInfoHeaderProps) => {
    const isPrivatePointsVisible = pointsPrivate !== undefined && pointsPrivate > 0

    return (
        <div className={styles.wrapper}>
            <div className={styles.pointsPublicContainer}>
                <UIGamePlayerInfoHeaderPointsPublic points={pointsPublic} color={color} />
            </div>
            <div className={styles.container} style={{'--player-color': color} as React.CSSProperties}>
                <div className={clsx(styles.background, {
                    [styles.toggledEndTurn]: isToggledEndTurn,
                })} />
                {isPrivatePointsVisible
                    ? <div className={styles.pointsPublicAndPrivateBuffer} />
                    : <div className={styles.pointsPublicBuffer} />}
                {isPrivatePointsVisible && <div className={styles.pointsPrivateContainer}>
                    <UIGamePlayerInfoHeaderPointsPrivate points={pointsPrivate} color={color} />
                </div>}
                <div className={styles.avatarContainer}>
                    <img src={avatar} className={styles.avatar} />
                </div>
                <span className={clsx(styles.username, {
                    [styles.usernameWithPrivatePoints]: isPrivatePointsVisible,
                })}>{username}</span>
            </div>
        </div>
    )
}
